import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

export const getChangeAutoRenewalButtonText = (
  isLinkingInProcess: boolean,
  isNeedPayment: boolean,
  licensesSubscriptionCost: number,
  isPendingAcceptanceAdvanced: boolean
) => {
  if (isPendingAcceptanceAdvanced) {
    return TEXTS.BILLING_LICENSES_ACCEPTANCE_ADVANCED_BUTTON_TEXT;
  }

  if (isLinkingInProcess) {
    return TEXTS.BILLING_BIND_CARD_LOADING(licensesSubscriptionCost);
  }

  if (isNeedPayment) {
    return TEXTS.BILLING_LICENSES_AMOUNT_BUTTON_TITLE(licensesSubscriptionCost);
  }

  return TEXTS.BILLING_LICENSES_SUBMIT_BUTTON_TEXT;
};
